export const VERIFYING = 'verifying' // 驗證中
export const VERIFIED = 'verified' // 已驗證
